import { render } from "./viewClientComponent.vue?vue&type=template&id=69fcb61b&scoped=true"
import script from "./viewClientComponent.vue?vue&type=script&lang=js"
export * from "./viewClientComponent.vue?vue&type=script&lang=js"

import "./viewClientComponent.vue?vue&type=style&index=0&id=69fcb61b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fcb61b"]])

export default __exports__